<form [ngClass]="{'mb-3': label.length > 0}">
    @for (item of formArray.controls; track $index; let first = $first) {
        @if (first) {
            <label
                class="form-label"
                [class]="labelClass"
                [for]="'email-' + (formArray.getRawValue().length - 1)">
                {{ label }}
            </label>

            @if (information) {
                <app-popover-icon class="ms-3" [popover]="information" />
            }
        }
        <div class="input-group" [ngClass]="{'mt-3': !first}">
            <input
                [class.is-invalid]="item.invalid && item.touched"
                (blur)="onTouch?.()"
                class="form-control"
                type="email"
                name="email"
                autocomplete="on"
                [formControl]="item"
                [id]="'email-' + $index"
                (keydown.enter)="item.markAsTouched()" />
            <button type="button" [class]="removeButtonClass" (click)="remove($index)">
                <i class="bi bi-trash"></i>
            </button>
        </div>
        <app-control-messages [control]="item" />
        <app-control-messages [control]="formArray" />
    }

    @if (canAddItem) {
        <div class="button-group text-end">
            <button type="button" [class]="addButtonClass" (click)="addItem()">
                {{ addEmailLabel }}
            </button>
        </div>
    } @else if (maxItemsLabel) {
        <div class="form-text mt-3" [class.text-danger]="exceedsMaxItems">{{ maxItemsLabel }}</div>
    }
</form>
